export const SEND_PASSWORD = 'moi/forgotPassword/SEND_PASSWORD';
export const SEND_PASSWORD_FINISHED = 'moi/forgotPassword/SEND_PASSWORD_FINISHED';
